import React, { Component } from 'react'
import { Trans, withTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import Consultations from '@services/Consultations'
import SentenceForm from '@modules/admin/sentence/Sentence.Form'
import { Loading } from '@modules/core/components/Loading'
import { DashboardHeader } from '@modules/admin/Admin.Header'

class SentenceUpdate extends Component {
  clientSentence = Consultations.sentence

  state = {
    id: this.props.match.params.sentenceId,
    deleteModal: false,
    sentence: undefined,
    isFetching: false,
  }

  componentDidMount() {
    this.setState({ isFetching: true })
    return this.clientSentence
      .show(this.state.id)
      .then((response) => {
        this.setState({ sentence: response.data, isFetching: false })
      })
      .catch((err) =>
        this.setState(undefined, () => {
          throw err
        })
      )
  }

  render() {
    const { sentence, isFetching } = this.state
    return (
      <div className="crud-wrapper ">
        <DashboardHeader title={<Trans>Editar frase</Trans>}>
          <Link className="btn btn-primary" to={`/sentence`}>
            <Trans>Volver</Trans>
          </Link>
        </DashboardHeader>
        <Loading isFetching={isFetching} />
        <div className="main-content">{sentence && <SentenceForm initialValues={sentence} />}</div>
      </div>
    )
  }
}
export default withTranslation()(SentenceUpdate)
